/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation PaymentDeleteMutation($paymentId: ID!) {
  PaymentDelete(paymentId: $paymentId) {
    id
    message
    status
  }
}
`
